import React, { Fragment, useEffect } from "react";
import { callAppConfigApi } from "../../commons/util/appConfigHelper";
import HomepageSkeleton from "../../pages/laxHomepage/components/HomepageSkeleton";

let appConfigRequest = null;

const refreshAppConfig = () => {
  if (!appConfigRequest) {
    appConfigRequest = callAppConfigApi().finally(() => {
      appConfigRequest = null;
    });
  }

  return appConfigRequest;
};

const LoadEnv = (props) => {
  useEffect(() => {
    //on app load
    configureAppConfig();
  }, []);

  const configureAppConfig = async () => {
    await refreshAppConfig();
    props.setIsEnvLoaded(true);
  };
  return <Fragment>{props.children || <HomepageSkeleton />}</Fragment>;
};

export default LoadEnv;
